import './App.css';
import { useState } from 'react';

const initialFriends = [
	{
		id: 1,
		name: 'daiyana',
		image: 'https://i.pravatar.cc/48?u=118814',
		balance: 160,
	},
	{
		id: 2,
		name: 'Alexa',
		image: 'https://i.pravatar.cc/48?u=933317',
		balance: -50,
	},
	{
		id: 3,
		name: 'Sohag',
		image: 'https://i.pravatar.cc/48?u=499475',
		balance: 0,
	},
];

function Button({ children, onClick }) {
	return (
		<button onClick={onClick} className='button'>
			{children}
		</button>
	);
}

// todo : when user click add friend and split bill form is closed

function App() {
	const [showAddFriend, setShowAddFriend] = useState(false);
	const [friends, setFriends] = useState(initialFriends);
	const [selectedFriend, setSelectedFriend] = useState(null);

	function handleShowAddFriend() {
		setShowAddFriend((show) => !show);
	}

	function handleAddFriend(newFriend) {
		setFriends((friends) => [...friends, newFriend]);
		setShowAddFriend(false);
	}

	function handleSelectFriend(friend) {
		// setSelectedFriend(friend);
		setSelectedFriend((cur) => (cur?.id === friend.id ? null : friend)); // toggle
		setShowAddFriend(false);
	}

	function handleSplitBill(value) {
		setFriends((friends) =>
			friends.map((friend) =>
				friend?.id === selectedFriend?.id
					? { ...friend, balance: friend.balance + value }
					: friend,
			),
		);

		setSelectedFriend(null);
	}

	return (
		<div className='app'>
			<div className='sidebar'>
				<h1>Friends</h1>

				<FriendList
					selectedFriend={selectedFriend}
					friends={friends}
					onSelection={handleSelectFriend}
				/>

				{showAddFriend && <FormAddFriend onAddFriend={handleAddFriend} />}

				<Button onClick={handleShowAddFriend}>
					{showAddFriend ? 'close' : 'Add Friend'}
				</Button>
			</div>

			{selectedFriend && (
				<FormSplitBill
					onSplitBill={handleSplitBill}
					selectedFriend={selectedFriend}
				/>
			)}
		</div>
	);
}

function FriendList({ friends, onSelection, selectedFriend }) {
	return (
		<ul>
			{friends.map((friend) => (
				<Friend
					selectedFriend={selectedFriend}
					friend={friend}
					key={friend.id}
					onSelection={onSelection}
				/>
			))}
		</ul>
	);
}

const Friend = ({ friend, onSelection, selectedFriend }) => {
	const isSelected = selectedFriend && selectedFriend?.id === friend?.id;

	return (
		<li className={isSelected ? 'selected' : ''}>
			<img src={friend.image} alt={friend.name} />
			<div>
				<h3>{friend.name}</h3>

				{friend.balance < 0 && (
					<p className='red'>
						You owe {friend.name} {Math.abs(friend.balance)}$
					</p>
				)}

				{friend.balance > 0 && (
					<p className='green'>
						{friend.name} own you {Math.abs(friend.balance)}$
					</p>
				)}

				{friend.balance === 0 && <p> You and {friend.name} are even</p>}
			</div>

			<Button onClick={() => onSelection(friend)}>
				{isSelected ? 'Close' : 'Select'}
			</Button>
		</li>
	);
};

function FormAddFriend({ onAddFriend }) {
	const [name, setName] = useState('');
	const [image, setImage] = useState('https://i.pravatar.cc/48');

	function handleSubmit(e) {
		e.preventDefault();

		if (!name || !image) return;

		const id = Math.floor(Math.random() * 1000000);

		const newFriend = {
			id,
			name,
			image: `${image}?=${id}`,
			balance: 0,
		};

		onAddFriend(newFriend);
		setName('');
		setImage('https://i.pravatar.cc/48');
	}

	return (
		<form className='form-add-friend' onSubmit={handleSubmit}>
			<label>🧑‍🤝‍🧑Friend Name </label>
			<input
				value={name}
				onChange={(e) => setName(e.target.value)}
				type='text'
			/>

			<label> 📷 Image Url</label>
			<input
				value={image}
				onChange={(e) => setImage(e.target.value)}
				type='text'
			/>
			<Button>Add Friend</Button>
		</form>
	);
}

function FormSplitBill({ selectedFriend, onSplitBill }) {
	const [billValue, setBillValue] = useState('');
	const [yourExpense, setYourExpense] = useState('');
	const paidByFriend = billValue ? billValue - yourExpense : '';
	const [whoIsPaying, setWhoIsPaying] = useState('user');

	function handleSubmit(e) {
		e.preventDefault();
		if (!billValue || !yourExpense) return;
		onSplitBill(whoIsPaying === 'user' ? paidByFriend : -yourExpense);
	}

	return (
		<form className='form-split-bill' onSubmit={handleSubmit}>
			<h2>Split a bill with {selectedFriend.name} </h2>

			<label> 💵 Bill Value</label>
			<input
				value={billValue}
				onChange={(e) => setBillValue(+e.target.value)}
				type='text'
			/>

			<label> 🕴️ Your Expense</label>
			<input
				type='text'
				value={yourExpense}
				onChange={(e) =>
					setYourExpense(
						+e.target.value > billValue ? yourExpense : +e.target.value,
					)
				}
			/>

			<label> 🧑‍🤝‍🧑{selectedFriend.name}'s Expense</label>
			<input type='text' disabled value={paidByFriend} />

			<label>🤑 Who is paying the bill</label>
			<select
				value={whoIsPaying}
				onChange={(e) => setWhoIsPaying(e.target.value)}
			>
				<option value='user'>Your</option>
				<option value='friend'>{selectedFriend.name}</option>
			</select>

			<Button>Split Bill</Button>
		</form>
	);
}

export default App;
